import React, { useState } from "react";
import { Order } from "../../interfaces/order";
import { hardDeleteOrder } from "../../services/orderService";

interface HardDeleteOrderProps {
  order: Order;
  onClose: () => void;
  onSuccess: () => void;
}

const HardDeleteOrder: React.FC<HardDeleteOrderProps> = ({
  order,
  onClose,
  onSuccess,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);

  const handleDeleteOrder = async () => {
    try {
      setLoadingSpinner(true);

      await hardDeleteOrder(order.orderID);

      onSuccess();
    } catch (error: any) {
      setErrorMessage(error.message || "An unexpected error occurred.");

      setLoadingSpinner(false);
    }
  };

  return (
    <>
      <div className="background-mask" onClick={() => onClose()}></div>
      <div className="filter-popup">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>Hard Delete Order</h2>
          <div>
            <b>Are you sure you would like to hard delete this order?</b>{" "}
          </div>
          <div>
            The order and candidate record will be permanently deleted and
            cannot be brought back.
          </div>
          <div className="error">
            If more than one order record for the candidate associated with this
            order is found, the operation will fail.{" "}
          </div>
        </div>
        <div className="filter-actions">
          <button className="smbtn btn-grey" onClick={() => onClose()}>
            Cancel
          </button>
          <button className={`smbtn btn-red`} onClick={handleDeleteOrder}>
            Hard Delete Order
          </button>
        </div>

        {errorMessage && (
          <div className="error-message error">
            <br></br>
            {errorMessage}
          </div>
        )}
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default HardDeleteOrder;
